import ReceiptLayout from '@/components/Receipt/ReceiptLayout';
import { useEffect } from 'react';
import { IMG_CASH_PICKUP_GUIDE_MAIN } from '@repo/assets';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { routes } from '@/constants/routes.const';
import { CashPickupIntroBox, TextButton } from '@repo/components';
import {
  FORCE_REFUND_CRUISE,
  FORCE_REFUND_CRUISE_KOR,
  FORCE_REFUND_PROCESS_BOXES,
  FORCE_REFUND_PROCESS_BOXES_KOR,
  REFUND_PROCESS_BOXES,
  REFUND_PROCESS_BOXES_KOR,
} from '@/constants/guide.const';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';

function RefundProcedure() {
  const history = useHistory();
  const { nationality, isUploadRequired, passportNumber } = useAppSelector(
    (state) => state,
  ) as IGlobalState;
  const selectedType = passportNumber
    ? localStorage.getItem(passportNumber)
    : '';
  const isCruise = passportNumber ? selectedType === 'Cruise' : false;

  const switchGuide = () => {
    if (isUploadRequired) {
      if (isCruise) {
        return nationality === 'KOR'
          ? FORCE_REFUND_CRUISE_KOR
          : FORCE_REFUND_CRUISE;
      }
      return nationality === 'KOR'
        ? FORCE_REFUND_PROCESS_BOXES_KOR
        : FORCE_REFUND_PROCESS_BOXES;
    } else {
      return nationality === 'KOR'
        ? REFUND_PROCESS_BOXES_KOR
        : REFUND_PROCESS_BOXES;
    }
  };

  const handleNext = () => {
    history.push(routes.home);
  };

  return (
    <ReceiptLayout hasPadding={false}>
      <MainImage
        src={IMG_CASH_PICKUP_GUIDE_MAIN}
        alt='CashPickupGuideMainImage'
      />
      <InnerWrapper>
        <Title>KTP Tax Refund Process</Title>
        <BoxWrapper>
          {switchGuide().map((box) => (
            <CashPickupIntroBox key={box.index} {...box} />
          ))}
        </BoxWrapper>
        <BtnWrapper>
          <TextButton
            title={nationality === 'KOR' ? '환급 받기' : 'Go to get Tax Refund'}
            onClick={handleNext}
          />
        </BtnWrapper>
      </InnerWrapper>
    </ReceiptLayout>
  );
}

export default RefundProcedure;

const MainImage = styled.img`
  width: 100%;
  height: auto;
`;

const Title = styled.h1`
  color: var(--KTP-Grayscale-Gray_02, #111);
  font-size: 24px;
  font-weight: 700;
  line-height: 150%; /* 36px */
  letter-spacing: -0.48px;
`;

const InnerWrapper = styled.div`
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const BoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
`;

const BtnWrapper = styled.div``;
